import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useHistory } from "react-router-dom";

function AlertModal({
  show,
  handleClose,
  handleAction,
  type,
  name,
  handleDelete,
}) {
  const history = useHistory();

  const handleProfileCompletion = () => {
    history.push("/settings");
    handleClose();
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="sm"
        className="rtlByMe"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "15px" }}>توجه</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "right" }}>
          درحال حاضر شما قادر به ساخت کانال و آپلود ویدئو نیستید. در صورت تمایل،
          پروفایل خود را تکمیل کنید و درخواست ارتقاء دسترسی خود را ارسال کنید.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleProfileCompletion}>
            تکمیل پروفایل
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AlertModal;
